<template>
  <el-dialog title="添加拉卡拉费率" :visible.sync="dialogVisible" width="700px" custom-class="rate-dialog"
    :before-close="closeRate">
    <div class="modal-wrapper">
      <!--选择省-->
      <div class="address-item scroll-box">
        <el-checkbox :indeterminate="indeterminate" v-model="all_active" @change="allProvinceFunc">全选</el-checkbox>
        <div class="province-item" :class="{ curr: index == province_index }" v-for="(item, index) in options"
          :key="index" @click.self="cityShow(index)">
          <el-checkbox :indeterminate="item.indeterminate" v-model="item.checked" :disabled="item.disabled"
            :label="item.value" @change="handleCheckedProvinceChange(index)">
            {{ item.name }}
          </el-checkbox>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeRate">取 消</el-button>
      <el-button type="primary" @click="confirmRate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    deepClone
  } from '@/utils/base';3

  export default {
    data() {
      return {
        /*弹窗是否打开*/
        dialogVisible: false,
        /*省*/
        rateList: [],
        /*选择省的角标*/
        province_index: null,
        /*当前选中的省*/
        activeProvinceId: [],
        /*当前对象*/
        activeModel: {},
        /*区域*/
        options: [],
        /*是否全部选中*/
        all_active: false,
        /*不确定*/
        indeterminate: false
      };
    },
    props: ['show_rate', 'rates'],
    created() {
      this.init();
    },
    methods: {
      /*初始化*/
      init() {
        this.dialogVisible = this.show_rate;
        this.setList(this.rates);
        this.options = deepClone(this.rates);
        this.isAll();
      },

      /*设置list*/
      setList(list) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.checked != true) {
            item.checked = false;
          }
          if (item.indeterminate != true) {
            item.indeterminate = false;
          }
          if (item.index == null) {
            item.index = [];
            item.disabled = false;
          }
        }
      },

      /*选择全部省*/
      allProvinceFunc() {
        if (!this.all_active) {
          this.all_active = false;
          this.indeterminate = false;
        } else {
          this.all_active = true;
          this.indeterminate = false;
        }

        for (let i = 0; i < this.options.length; i++) {
          let item = this.options[i];
          if (item.disabled != true) {
            item.checked = this.all_active;
            item.indeterminate = this.indeterminate;
          }
        }
      },

      /*选择省*/
      handleCheckedProvinceChange(i) {
        this.province_index = i;
        this.options[i].indeterminate = false;
        if (this.options[i].checked && this.options[i].disabled != true) {
          this.options[i].checked = true;
        } else {
          if (this.options[i].disabled != true) {
            this.options[i].checked = false;
          }
        }
        this.isAll();
      },
      /*判断是否选中了所有的省和市*/
      isAll() {
        let n = this.isChooseAll(this.options);
        if (n == 0) {
          this.all_active = false;
          this.indeterminate = false;
        } else if (n == 2) {
          this.all_active = true;
          this.indeterminate = false;
        } else {
          this.all_active = false;
          this.indeterminate = true;
        }
      },

      /*判断列表是否全选*/
      isChooseAll(list) {
        let allcount = 0;
        if (Object.prototype.toString.call(list) == '[object Array]') {
          for (let i = 0; i < list.length; i++) {
            if (Object.prototype.toString.call(list[i].index) == '[object Array]') {
              if (list[i]['checked'] == true || list[i][
                  'indeterminate'
                ] == true) {
                allcount++;
              }
            } else {
              if (list[i]['checked'] == true || list[i]['indeterminate'] == true) {
                allcount++;
              }
            }
          }
          if (allcount == list.length) {
            return 2;
          } else {
            if (allcount > 0) {
              return 1;
            } else {
              return 0;
            }
          }
        } else {
          return 2;
        }
      },

      /*选择省 - 只是展示城市列表*/
      cityShow(i) {
        this.province_index = i;
      },

      /*关闭弹窗*/
      closeRate() {
        this.dialogVisible = false;
        this.$emit('closeRate', {
          statu: false,
          type: 'cancel'
        });
      },

      /*确认并关闭弹窗*/
      confirmRate() {
        this.dialogVisible = false;
        let obj = {
          statu: false,
          type: 'confirm',
          this_rate: this.options,
          total_rate: []
        };
        this.$emit('closeRate', obj);
      }


    }
  };
</script>

<style>
  .rate-dialog .el-dialog__header {
    border-bottom: 1px solid #dddddd;
  }

  .rate-dialog .el-dialog__body {
    padding: 20px;
  }

  .rate-dialog .modal-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .rate-dialog .scroll-box {
    overflow-y: auto;
  }

  .rate-dialog .address-item {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border: 1px solid #eee;
    height: 400px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .rate-dialog .el-checkbox {
    padding: 8px 10px 8px 22px;
    min-height: 20px;
    box-sizing: border-box;
    margin-right: 0;
    position: relative;
  }

  .rate-dialog .province-item {
    cursor: pointer;
  }

  .rate-dialog .province-item:hover,
  .rate-dialog .province-item.curr {
    background: #eeeeee;
  }

  /* .rate-dialog .address-item .el-checkbox {
  display: block;
  margin-right: 0;
}

.rate-dialog .address-item .el-checkbox-item:hover,
.rate-dialog .address-item .active-checkbox {
  background: #eeeeee;
}
.rate-dialog .address-item .el-checkbox__input {
  position: absolute;
  left: 10px;
  top: 10px;
}
.rate-dialog .address-item .el-checkbox__label {
  display: block;
} */
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/applyment/dialog/LakalaRate.vue